import $ from 'jquery';

const addAccessValidation = (form, opts) => {
    const $form = $(form);
    if (!$form.find(`[name=${opts.selectors.accessValidator}]`).length) {
        return;
    }

    const $boxes = $form.find(opts.selectors.accessCheckboxes);
    $boxes.off('change').on('change', () => {
        $form.find(`[name=${opts.selectors.accessValidator}]`).valid();
    });

    const userFormSettings = $form.data('validator').settings;
    userFormSettings.ignore = '';
    userFormSettings.rules[opts.selectors.accessValidator].required = () => {
        return ($boxes.filter(':checked').length === 0);
    };
};

const addSubAccountAccessValidation = (form, opts) => {
    const $form = $(form);
    if (!$form.find(`[name=${opts.selectors.accessSubAccountValidator}]`).length) {
        return;
    }

    const $boxes = $form.find(opts.selectors.accessSubAccountCheckboxes);
    $boxes.off('change').on('change', () => {
        $form.find(`[name=${opts.selectors.accessSubAccountValidator}]`).valid();
    });

    const userFormSettings = $form.data('validator').settings;
    userFormSettings.ignore = '';
    userFormSettings.rules[opts.selectors.accessSubAccountValidator].required = () => {
        return ($boxes.filter(':checked').length === 0);
    };
};

function getCookie(name) {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return '';
}

function checkCookie(loginData, url = '/LoginPage/GetLoginPageUrl') {
    // check cookie. if current utc > cookie's utc
    const expiresCookie = getCookie('session.expiresAtUtc');

    if (expiresCookie) {
        const unixTimestamp = new Date().getTime();

        if (unixTimestamp > expiresCookie) {
            $.get(url, loginData).done(data => window.location.href = data.RedirectUrl);
        }
    }
}

const initLoginSessionWatch = (elm) => {
    if (!elm.length) {
        return;
    }

    const loginData = {
        isUserCreator: elm.data('is-user-creator'),
        isUserImpersonator: elm.data('is-user-impersonator'),
        userName: elm.data('username'),
        languageName: elm.data('language-name'),
        currentPageUrl: window.location.pathname + window.location.search
    };
    const queryMlsec = elm.data('query-mlsec');

    setInterval(() => checkCookie(loginData), queryMlsec);

};

const init = (opts) => {
    const defaults = {
        selectors: {
            loginDataElm: '#js-login-data',
            form: '.js-user-form',
            accessCheckboxes: '.js-user-access',
            accessSubAccountCheckboxes: '.js-user-access-subaccount',
            accessValidator: 'user-access',
            accessSubAccountValidator: 'user-access-subaccount'
        }
    };

    const options = $.extend(true, defaults, opts);

    initLoginSessionWatch($(options.selectors.loginDataElm));

    $(options.selectors.form).each((i, form) => addAccessValidation(form, options));
    $(options.selectors.form).each((i, form) => addSubAccountAccessValidation(form, options));
};

export default {
    init
};
